export interface ParsedTime {
  hour: string
  minute: string
  second: string
}

/**
 * Parse time string in HH:MM:SS format to individual components
 * @param timeString - Time in "HH:MM:SS" format
 * @returns Object with hour, minute, second as strings
 */
export const parseIncrementTime = (timeString: string): ParsedTime => {
  if (!timeString) return { hour: '00', minute: '00', second: '00' }

  const parts = timeString.split(':')
  return {
    hour: parts[0] || '00',
    minute: parts[1] || '00',
    second: parts[2] || '00',
  }
}

/**
 * Format individual time components to HH:MM:SS string
 * @param hour - Hour string (00-23)
 * @param minute - Minute string (00-59)
 * @param second - Second string (00-59)
 * @returns Formatted time string "HH:MM:SS"
 */
export const formatIncrementTime = (hour: string, minute: string, second: string): string => {
  return `${hour}:${minute}:${second}`
}
